import React, { useMemo } from 'react';
import '../../styles/layout.css';

const COLORS = ['#eef2ff', '#c7d4fd', '#97b0fc', '#5a82f8', '#1246d6'];
const DOWS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export default function HeatmapChart({ utilData }) {
  const { weeks, maxV } = useMemo(() => {
    const today = new Date('2025-03-30');
    const cells = [];
    for (let w = 12; w >= 0; w--) {
      for (let d = 0; d < 7; d++) {
        const dt = new Date(today);
        dt.setDate(today.getDate() - w * 7 - d);
        const key = dt.toISOString().slice(0, 10);
        const rows = utilData.filter(r => r.date === key);
        cells.push({
          date: key,
          val: rows.length ? rows.reduce((s, r) => s + (r.hrs || 0), 0) / rows.length : 0,
          dow: d,
        });
      }
    }
    const maxV = Math.max(...cells.map(c => c.val), 1);
    const weeksArr = [];
    for (let w = 0; w < 13; w++) weeksArr.push(cells.slice(w * 7, w * 7 + 7));
    return { weeks: weeksArr, maxV };
  }, [utilData]);

  const gc = v => v === 0 ? '#f0f3f8' : COLORS[Math.min(4, Math.floor(v / maxV * 4.99))];

  return (
    <div className="hmap-wrap">
      <div className="hmap-grid">
        {DOWS.map((day, di) => (
          <div className="hmap-row" key={day}>
            <div className="hmap-wlbl">{di % 2 === 0 ? day : ''}</div>
            {weeks.map((w, wi) => {
              const c = w[di];
              return (
                <div
                  key={wi}
                  className="hmap-cell"
                  style={{ background: gc(c.val) }}
                  data-tip={`${c.date}: ${c.val.toFixed(1)}h`}
                />
              );
            })}
          </div>
        ))}
      </div>
      <div className="hmap-leg">
        Less
        <div className="hmap-sw">
          {COLORS.map(c => (
            <div key={c} className="hmap-s" style={{ background: c }} />
          ))}
        </div>
        More
      </div>
    </div>
  );
}
